export const booleanOptions = [
  { value: "true", name: "نعم" },
  { value: "false", name: "لا" },
];

export const singleBooleanOptions = [{ value: "true", name: "نعم" }];
